/**
 * RESPONSIBILITY: draw the one line an event wants read on its own.
 *
 * "No registration required" is not a paragraph and not a heading; it is an aside that
 * has to survive being skimmed past. Its own band, so an editor can put it where it
 * answers the question that prompts it.
 */
import { THEME } from '@app/sections';
import { Band } from './Band';
import type { BandProps } from './kind';

export function Note({ s }: BandProps) {
  if (!s.note) return null;

  return (
    <Band theme={THEME.Note}>
      <p className="ev-note">{s.note}</p>
    </Band>
  );
}
